import { useTranslation } from 'react-i18next';
import checkForSupportedLanguageCode from './checkForSupportedLanguageCode';

const useSupportedLanguage = () => {
  const { i18n } = useTranslation();
  return checkForSupportedLanguageCode(i18n.language);
};

export default useSupportedLanguage;
